module.exports = __webpack_public_path__ + "static/media/logo_cassina.37b8af38.svg";